import React, { useState, useEffect } from "react";
import { Box, Button, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { authFetch } from '../utils/authFetch';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function DeleteLapsDropdown({ laps, onDelete }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [lapList, setLapList] = useState(laps);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const open = Boolean(anchorEl);

  // Sync lapList with laps prop
  useEffect(() => {
    setLapList(laps);
  }, [laps]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    // Always fetch latest laps when opening the menu
    authFetch(`${BACKEND_URL}/laps/`)
      .then(res => {
        if (res && res.ok) return res.json();
        return null;
      })
      .then(data => {
        if (data) setLapList([...data].sort());
      });
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDelete = (lapId) => {
    onDelete(lapId);
    handleClose();
  };
  const handleDeleteAll = () => {
    setConfirmOpen(true);
  };
  const handleConfirmDeleteAll = () => {
    onDelete('ALL');
    setConfirmOpen(false);
    handleClose();
  };
  const handleCancelDeleteAll = () => {
    setConfirmOpen(false);
  };

  return (
    <Box sx={{ display: 'inline-block' }}>
      <Button
        variant="outlined"
        color="secondary"
        startIcon={<DeleteIcon />}
        onClick={handleClick}
        sx={{
          minWidth: '200px',
          maxWidth: '200px',
          height: 40,
          fontSize: '1rem',
          justifyContent: 'flex-start',
        }}
      >
        Delete Laps
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleDeleteAll} sx={{ color: 'red' }}>Delete All Laps</MenuItem>
        {lapList.map(lap => (
          <MenuItem key={lap} onClick={() => handleDelete(lap)}>
            {lap}
          </MenuItem>
        ))}
      </Menu>
      {/* Confirmation Dialog for Delete All */}
      <Dialog open={confirmOpen} onClose={handleCancelDeleteAll}>
        <DialogTitle>Confirm Delete All Laps</DialogTitle>
        <DialogContent>
          Are you sure you want to delete <b>all laps</b>? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDeleteAll} color="primary">Cancel</Button>
          <Button onClick={handleConfirmDeleteAll} color="secondary" variant="contained">Delete All</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default DeleteLapsDropdown;
